import React, { createContext, useContext, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getGtmScript, getIframeSnippet } from './getters';

const GoogleTagManagerContext = createContext(undefined);

const GoogleTagManagerProvider = ({ children, gtmId }) => {
  const [scriptContainer] = useState(() => {
    const scriptElem = document.createElement('script');

    scriptElem.innerHTML = getGtmScript(gtmId);

    return scriptElem;
  });
  const [iframeContainer] = useState(() => {
    const noScriptElem = document.createElement('noscript');

    noScriptElem.innerHTML = getIframeSnippet(gtmId);

    return noScriptElem;
  });

  useLayoutEffect(() => {
    document.head.insertBefore(scriptContainer, document.head.childNodes[0]);
    document.body.insertBefore(iframeContainer, document.body.childNodes[0]);

    return () => {
      scriptContainer.remove();
      iframeContainer.remove();
    };
  }, [scriptContainer, iframeContainer]);

  const sendToGTM = (data = {}) => {
    if (window.dataLayer) {
      window.dataLayer.push(data);
    }
  };

  return (
    <GoogleTagManagerContext.Provider value={{ sendToGTM }}>
      {children}
    </GoogleTagManagerContext.Provider>
  );
};

GoogleTagManagerProvider.propTypes = {
  children: PropTypes.node.isRequired,
  gtmId: PropTypes.string.isRequired
};

export default GoogleTagManagerProvider;

export const useGoogleTagManager = () => {
  const context = useContext(GoogleTagManagerContext);

  if (!context) {
    throw new Error('useGoogleTagManager must be used within its provider.');
  }

  return context;
};
